var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dhxwList"},[_c('div',{staticClass:"mains"},[_c('div',{staticClass:"first"},[(this._isMobile() )?_c('Navigation',{attrs:{"navigationdatas":_vm.navigationListApp}}):_c('Navigation',{attrs:{"navigationdatas":_vm.navigationList}}),_vm._v(" "),_c('Details',{staticClass:"details"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486f4318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/project/DhxwDetails.vue
// module id = null
// module chunks = 